export interface AdminApiState {
    adminApiData: any;
    loading: boolean;
    error: null | string;
}


export enum AdminApiActionTypes {
    FETCH_ADMIN_API_DATA = "FETCH_ADMIN_API_DATA",
    FETCH_ADMIN_API_DATA_SUCCESS = "FETCH_ADMIN_API_DATA_SUCCESS",
    FETCH_ADMIN_API_DATA_ERROR = "FETCH_ADMIN_API_DATA_ERROR",
}

export type AdminApiAction =
    | { type: AdminApiActionTypes.FETCH_ADMIN_API_DATA }
    | { type: AdminApiActionTypes.FETCH_ADMIN_API_DATA_SUCCESS; payload: any[] }
    | { type: AdminApiActionTypes.FETCH_ADMIN_API_DATA_ERROR; payload: string };

